/* eslint-disable react/forbid-prop-types */

import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import {
  MdEast,
  MdKeyboardArrowRight,
  MdOutlineCompareArrows,
} from 'react-icons/md';
import { Col, Row } from 'react-bootstrap';
// import { useNavigate } from 'react-router-dom';
import differenceInCalendarDays from 'date-fns/differenceInCalendarDays';
// import AppButton from '../../shared/components/app-button/AppButton';
import {
  formatDate,
  formatTimeStringAmPmFormat,
  getNewDate,
  isMobileWidth,
} from '../../shared/helper-utils/appUtils';
import {
  DATE_MONTH_YEAR_VIEW_FORMAT,
  TODAY_DATE,
} from '../../shared/constants/Constants';
import AppLink from '../../shared/components/app-link/AppLink';
import AppIconButton from '../../shared/components/app-icon-button/AppIconButton';
import FlightBookingDetailsSidebar from './FlightBookingDetailsSidebar';
import AppFlightLogo from '../../shared/components/app-flight-logo/AppFlightLogo';
import { useAppContext } from '../../saas/AppConfigWrapper';

const tripTypeDict = {
  oneway: 'One Way',
  roundtrip: 'Round Trip',
  multicity: 'Multi City',
};

function FlightListCard({ transaction, txType }) {
  const { appConfig } = useAppContext();
  // const navigate = useNavigate();
  const onwardSectorsRef = useRef([]);
  const returnSectorsRef = useRef([]);
  const flightRecordRef = useRef(undefined);
  const [hasSectors, setHasSectors] = useState(false);
  const selectedTxidRef = useRef(undefined);
  const [showDetailsSidebar, setShowDetailsSidebar] = useState(false);

  const getNumdays = () => {
    const today = getNewDate(TODAY_DATE);
    const bookingDate = getNewDate(transaction.FlightRecord.JDate);
    const diff = differenceInCalendarDays(bookingDate, today);
    return `in ${diff} day(s)`;
  };

  const getTerminal = (terminal) => {
    if (
      terminal !== undefined &&
      terminal !== null &&
      terminal !== '' &&
      terminal !== '-'
    ) {
      const terNumber = terminal
        .toLowerCase()
        .replace('terminal', '')
        .replace('t', '');
      return `Terminal: ${terNumber}`;
    }
    return '';
  };

  const getFightNumbers = (sectors) => {
    const fltnums = [];
    sectors.forEach((sector) => {
      fltnums.push(`${sector.Carrier} ${sector.FlightNumber}`);
    });

    return fltnums.join(', ');
  };

  const getInitData = () => {
    const { FlightRecord, SectorRecords } = transaction;
    flightRecordRef.current = FlightRecord;
    if (SectorRecords !== '') {
      let { SectorRecord } = SectorRecords;
      SectorRecord = Array.isArray(SectorRecord)
        ? SectorRecord
        : [SectorRecord];
      const OnwardSectors = SectorRecord.filter(
        (sector) => sector.FlightType.toLowerCase() === 'onward',
      );
      const ReturnSectors = SectorRecord.filter(
        (sector) => sector.FlightType.toLowerCase() === 'return',
      );
      onwardSectorsRef.current = OnwardSectors;
      returnSectorsRef.current = ReturnSectors;
      setHasSectors(true);
    }
  };
  useEffect(() => {
    getInitData();
  }, []);

  const getMultiCityJourney = () => {
    if (flightRecordRef.current.JType.toLowerCase() === 'multicity') {
      const { SectorRecords } = transaction;
      if (SectorRecords !== '') {
        let { SectorRecord } = SectorRecords;
        SectorRecord = Array.isArray(SectorRecord)
          ? SectorRecord
          : [SectorRecord];
        const tripNumbers = [];
        SectorRecord.forEach((sector) => {
          if (tripNumbers.indexOf(sector.TripNumber) === -1) {
            tripNumbers.push(sector.TripNumber);
          }
        });
        tripNumbers.sort(
          (tripNumber1, tripNumber2) => tripNumber2 > tripNumber1,
        );
        const tripSectors = [];
        tripNumbers.forEach((trip) => {
          const tripSector = SectorRecord.filter((x) => x.TripNumber === trip);
          tripSector.sort(
            (trip1, trip2) => trip2.SectorNumber > trip1.SectorNumber,
          );
          tripSectors.push(
            `${tripSector[0].Origin} - ${
              tripSector[tripSector.length - 1].Destination
            }`,
          );
        });
        return (
          <div className="d-flex gap-1 align-items-center">
            {tripSectors.map((t, index) => (
              <React.Fragment key={t}>
                <span className="fs-18 fw-600">{t.split(' - ')[0]}</span>
                <span className="fs-4 secondary-color">
                  <MdEast />
                </span>
                <span className="fs-18 fw-600">{t.split(' - ')[1]}</span>
                {index !== tripSectors.length - 1 && (
                  <span className="fs-18 fw-300">|</span>
                )}
              </React.Fragment>
            ))}
          </div>
        );
      }
      return '';
    }
    return '';
  };

  const handleOpenDetailsSidebar = (txid) => {
    selectedTxidRef.current = txid;
    setShowDetailsSidebar(true);
  };

  const handleCloseDetailsSidebar = () => {
    setShowDetailsSidebar(false);
    selectedTxidRef.current = undefined;
  };

  return (
    <div className="flight-list-card">
      {hasSectors &&
        onwardSectorsRef.current.length > 0 &&
        (isMobileWidth() ? (
          <div className="flight-list-card_mobile">
            <div>
              <div className="d-flex flex-column">
                <div className="d-flex align-items-center justify-content-between">
                  <div
                    className="d-flex flex-column"
                    style={{ minWidth: '50px' }}
                  >
                    <span className="fs-10">
                      {formatTimeStringAmPmFormat(
                        onwardSectorsRef.current[0].DepartureTime,
                      )}
                    </span>
                    <span className="fs-14 fw-600">
                      {flightRecordRef.current.Origin}
                    </span>
                  </div>
                  <div className="fs-5 secondary-color">
                    <MdEast />
                  </div>
                  <div className="d-flex flex-column">
                    <span className="fs-10">
                      {formatTimeStringAmPmFormat(
                        onwardSectorsRef.current[
                          onwardSectorsRef.current.length - 1
                        ].ArrivalTime,
                      )}
                    </span>
                    <span className="fs-14 fw-600">
                      {flightRecordRef.current.Destination}
                    </span>
                  </div>
                  <div className="d-flex flex-column align-items-center">
                    <span className="fs-10 fw-300">JDate</span>
                    <span className="fs-14 fw-600">
                      {formatDate(
                        getNewDate(onwardSectorsRef.current[0].JourneyDate),
                        DATE_MONTH_YEAR_VIEW_FORMAT,
                      )}
                    </span>
                  </div>
                  <div className="d-flex flex-column align-items-center">
                    <span className="fs-10 fw-300">PNR</span>
                    <span className="fs-14 fw-600">
                      {flightRecordRef.current.AirlinePnr.split(',')[0]}
                    </span>
                  </div>
                  <div className="d-flex flex-column align-items-center">
                    <span className="fs-10 fw-300">Carrier</span>
                    <span className="fs-14 fw-600">
                      {onwardSectorsRef.current[0].Carrier.substring(0, 2)}
                    </span>
                  </div>
                </div>

                {returnSectorsRef.current.length > 0 && (
                  <div className="d-flex align-items-center justify-content-between mt-2">
                    <div
                      className="d-flex flex-column"
                      style={{ minWidth: '50px' }}
                    >
                      <span className="fs-10">
                        {formatTimeStringAmPmFormat(
                          returnSectorsRef.current[0].DepartureTime,
                        )}
                      </span>
                      <span className="fs-14 fw-600">
                        {flightRecordRef.current.Destination}
                      </span>
                    </div>
                    <div className="fs-5 secondary-color">
                      <MdEast />
                    </div>
                    <div className="d-flex flex-column">
                      <span className="fs-10">
                        {formatTimeStringAmPmFormat(
                          returnSectorsRef.current[
                            returnSectorsRef.current.length - 1
                          ].ArrivalTime,
                        )}
                      </span>
                      <span className="fs-14 fw-600">
                        {flightRecordRef.current.Origin}
                      </span>
                    </div>
                    <div className="d-flex flex-column align-items-center">
                      <span className="fs-10 fw-300">JDate</span>
                      <span className="fs-14 fw-600">
                        {formatDate(
                          getNewDate(returnSectorsRef.current[0].JourneyDate),
                          DATE_MONTH_YEAR_VIEW_FORMAT,
                        )}
                      </span>
                    </div>
                    <div className="d-flex flex-column align-items-center">
                      <span className="fs-10 fw-300">PNR</span>
                      <span className="fs-14 fw-600">
                        {flightRecordRef.current.AirlinePnr.split(',')[1]}
                      </span>
                    </div>
                    <div className="d-flex flex-column align-items-center">
                      <span className="fs-10 fw-300">Carrier</span>
                      <span className="fs-14 fw-600">
                        {returnSectorsRef.current[0].Carrier.substring(0, 2)}
                      </span>
                    </div>
                  </div>
                )}
              </div>
              <div className="border-top mt-2">
                <div className="d-flex justify-content-between align-items-center">
                  <div className="d-flex flex-1 justify-content-between">
                    <div className="d-flex flex-column">
                      <span className="fs-10 fw-300">Passenger Name</span>
                      <span className="fs-14 fw-600">
                        {flightRecordRef.current.PassengerFirstName}{' '}
                        {flightRecordRef.current.PassengerLastName}
                      </span>
                    </div>
                    <div className="d-flex flex-column">
                      <span className="fs-10 fw-300">Price</span>
                      <span className="fs-14 fw-600">
                        {appConfig?.appCurrency}{' '}
                        {flightRecordRef.current.FareQuoteAmount}
                      </span>
                    </div>
                  </div>
                  <AppIconButton
                    className="align-items-end d-flex fs-1 justify-content-center pt-2 py-0"
                    variant="transparent"
                    onClick={() =>
                      handleOpenDetailsSidebar(flightRecordRef.current.Txid)
                    }
                  >
                    <MdKeyboardArrowRight className="primary-color" />
                  </AppIconButton>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <>
            <div className="d-flex justify-content-between align-items-center flight-list-card_tx-details">
              <div className="d-flex gap-4 align-items-center">
                <div className="flight-list-card_tx-details_flight-icon">
                  <AppFlightLogo
                    width="30px"
                    height="30px"
                    carrier={flightRecordRef.current.Carrier.substring(0, 2)}
                    className="vertical-bottom"
                  />
                </div>
                <div className="d-flex flex-column">
                  <div className="d-flex align-items-center gap-1">
                    {flightRecordRef.current.JType.toLowerCase() ===
                    'multicity' ? (
                      getMultiCityJourney()
                    ) : (
                      <div className="d-flex gap-1 align-items-center">
                        <span className="fs-18 fw-600">
                          {flightRecordRef.current.Origin}
                        </span>

                        <span className="fs-4 secondary-color">
                          {flightRecordRef.current.JType.toLowerCase() ===
                          'roundtrip' ? (
                            <MdOutlineCompareArrows />
                          ) : (
                            <MdEast />
                          )}
                        </span>

                        <span className="fs-18 fw-600">
                          {flightRecordRef.current.Destination}
                        </span>
                      </div>
                    )}
                    {txType === 'upcoming' && (
                      <div className="upcoming-days-span">{getNumdays()}</div>
                    )}
                  </div>
                  <div className="grey-color flight-list-card_tx-details_trip-type">
                    <span className=" fw-500 fs-12">
                      {`${
                        tripTypeDict[
                          flightRecordRef.current.JType.toLowerCase()
                        ]
                      } Flight`}
                    </span>{' '}
                    |{' '}
                    <span className=" fw-500 fs-12">
                      Booking ID-{' '}
                      <AppLink
                        linkText={flightRecordRef.current.Txid}
                        // isLink
                        // target="_blank"
                        // href={`/flight/order-details/${flightRecordRef.current.Txid}`}
                      />
                    </span>
                  </div>
                  <div className="fs-10 fw-300">
                    PNR - {flightRecordRef.current.AirlinePnr}
                  </div>
                </div>
              </div>
              <div className="d-flex flex-column gap-1 align-items-center">
                <span className="fs-10 fw-300">Booked on</span>
                <span className="fs-12 fw-500">
                  {formatDate(
                    getNewDate(
                      flightRecordRef.current.BookingDate.split(' ')[0],
                    ),
                    DATE_MONTH_YEAR_VIEW_FORMAT,
                  )}{' '}
                  {flightRecordRef.current.BookingDate.split(' ')[1]}
                </span>
              </div>
              <div className="d-flex gap-3 align-items-center fw-500">
                <AppLink
                  linkText="E-Ticket"
                  variant="primary"
                  isLink
                  target="_blank"
                  href={`/flight/ticket/${flightRecordRef.current.Txid}`}
                />
                {txType !== 'cancelled' && (
                  <AppLink
                    linkText="Invoice"
                    variant="primary"
                    isLink
                    target="_blank"
                    href={`/flight/invoice/${flightRecordRef.current.Txid}`}
                  />
                )}
              </div>
            </div>
            <div className="flight-list-card_flight-details">
              <Row>
                {flightRecordRef.current.JType.toLowerCase() === 'multicity' ? (
                  <Col lg={10} md={10} sm={12} xs={12}>
                    {onwardSectorsRef.current.map((sec, index) => (
                      <Row key={sec.origin} className="mb-3">
                        <Col lg={4} md={4} sm={6} xs={6}>
                          <div>
                            {index === 0 && (
                              <div className="fs-12 primary-color mb-1">
                                Depart
                              </div>
                            )}
                            <div className="fw-600 fs-16 d-flex align-items-center gap-1">
                              <span>
                                {formatDate(
                                  getNewDate(sec.JourneyDate),
                                  DATE_MONTH_YEAR_VIEW_FORMAT,
                                )}
                              </span>
                              <span>
                                {formatTimeStringAmPmFormat(sec.DepartureTime)}
                              </span>
                            </div>
                            <div className="fs-12 grey-color">
                              {`${sec.Origin} - ${
                                sec.OriginFullName
                              } ${getTerminal(
                                sec.AirportTerminal.toString().split(',')[0],
                              )}`}
                            </div>
                          </div>
                        </Col>
                        <Col lg={4} md={4} sm={6} xs={6}>
                          <div>
                            {index === 0 && (
                              <div className="fs-12 primary-color mb-1">
                                Arrival
                              </div>
                            )}
                            <div className="fw-600 fs-16 d-flex align-items-center gap-1">
                              {sec.ArrivalDate && (
                                <span>
                                  {formatDate(
                                    getNewDate(sec.ArrivalDate),
                                    DATE_MONTH_YEAR_VIEW_FORMAT,
                                  )}
                                </span>
                              )}
                              <span>
                                {formatTimeStringAmPmFormat(sec.ArrivalTime)}
                              </span>
                            </div>
                            <div className="fs-12 grey-color">
                              {`${sec.Destination} - ${
                                sec.DestinationFullName
                              } ${getTerminal(
                                sec.AirportTerminal.toString().split(',')[1],
                              )}`}
                            </div>
                          </div>
                        </Col>
                        <Col
                          lg={2}
                          md={2}
                          sm={6}
                          xs={12}
                          className="d-flex align-items-center"
                        >
                          <div className="d-flex flex-column align-items-center gap-1 justify-content-center">
                            <div className="secondary-color">
                              {`${sec.Carrier} ${sec.FlightNumber}`}
                            </div>
                            <div className="fs-12 grey-color">
                              {flightRecordRef.current.PassengerFirstName}{' '}
                              {flightRecordRef.current.PassengerLastName}
                            </div>
                          </div>
                        </Col>
                        <Col
                          lg={2}
                          md={2}
                          sm={6}
                          xs={12}
                          className="d-flex align-items-center"
                        >
                          <div>
                            <AppFlightLogo
                              width="30px"
                              height="30px"
                              carrier={sec.Carrier.substring(0, 2)}
                              className="vertical-bottom"
                              style={{
                                marginLeft: '5px',
                              }}
                            />
                          </div>
                        </Col>
                      </Row>
                    ))}
                  </Col>
                ) : (
                  <Col lg={10} md={10} sm={12} xs={12}>
                    <Row>
                      <Col lg={4} md={4} sm={6} xs={6}>
                        <div>
                          <div className="fs-12 primary-color mb-1">Depart</div>
                          <div className="fw-600 fs-16 d-flex align-items-center gap-1">
                            <span>
                              {formatDate(
                                getNewDate(
                                  onwardSectorsRef.current[0].JourneyDate,
                                ),
                                DATE_MONTH_YEAR_VIEW_FORMAT,
                              )}
                            </span>
                            <span>
                              {formatTimeStringAmPmFormat(
                                onwardSectorsRef.current[0].DepartureTime,
                              )}
                            </span>
                          </div>
                          <div className="fs-12 grey-color">
                            {`${onwardSectorsRef.current[0].Origin} - ${
                              onwardSectorsRef.current[0].OriginFullName
                            } ${getTerminal(
                              onwardSectorsRef.current[0].AirportTerminal.toString().split(
                                ',',
                              )[0],
                            )}`}
                          </div>
                        </div>
                      </Col>
                      <Col lg={4} md={4} sm={6} xs={6}>
                        <div>
                          <div className="fs-12 primary-color mb-1">
                            Arrival
                          </div>
                          <div className="fw-600 fs-16 d-flex align-items-center gap-1">
                            {onwardSectorsRef.current[
                              onwardSectorsRef.current.length - 1
                            ].ArrivalDate && (
                              <span>
                                {formatDate(
                                  getNewDate(
                                    onwardSectorsRef.current[
                                      onwardSectorsRef.current.length - 1
                                    ].ArrivalDate,
                                  ),
                                  DATE_MONTH_YEAR_VIEW_FORMAT,
                                )}
                              </span>
                            )}
                            <span>
                              {formatTimeStringAmPmFormat(
                                onwardSectorsRef.current[
                                  onwardSectorsRef.current.length - 1
                                ].ArrivalTime,
                              )}
                            </span>
                          </div>
                          <div className="fs-12 grey-color">
                            {`${
                              onwardSectorsRef.current[
                                onwardSectorsRef.current.length - 1
                              ].Destination
                            } - ${
                              onwardSectorsRef.current[
                                onwardSectorsRef.current.length - 1
                              ].DestinationFullName
                            } ${getTerminal(
                              onwardSectorsRef.current[
                                onwardSectorsRef.current.length - 1
                              ].AirportTerminal.toString().split(',')[1],
                            )}`}
                          </div>
                        </div>
                      </Col>
                      <Col
                        lg={2}
                        md={2}
                        sm={6}
                        xs={12}
                        className="d-flex align-items-center"
                      >
                        <div className="d-flex flex-column align-items-center gap-1 justify-content-center">
                          <div className="secondary-color">
                            {getFightNumbers(onwardSectorsRef.current)}
                          </div>
                          <div className="fs-12 grey-color">
                            {flightRecordRef.current.PassengerFirstName}{' '}
                            {flightRecordRef.current.PassengerLastName}
                          </div>
                        </div>
                      </Col>
                      <Col
                        lg={2}
                        md={2}
                        sm={6}
                        xs={12}
                        className="d-flex align-items-center"
                      >
                        <div>
                          <AppFlightLogo
                            width="30px"
                            height="30px"
                            carrier={onwardSectorsRef.current[0].Carrier.substring(
                              0,
                              2,
                            )}
                            className="vertical-bottom"
                            style={{
                              marginLeft: '5px',
                            }}
                          />
                        </div>
                      </Col>
                    </Row>
                    {returnSectorsRef.current.length > 0 && (
                      <Row>
                        <Col lg={12} md={12} sm={12} xs={12}>
                          <div className="m-2 secondary-color fw-500">
                            Return Sectors
                          </div>
                        </Col>
                        <Col lg={4} md={4} sm={6} xs={6}>
                          <div>
                            <div className="fs-12 primary-color mb-1">
                              Depart
                            </div>
                            <div className="fw-600 fs-16 d-flex align-items-center gap-1">
                              <span>
                                {formatDate(
                                  getNewDate(
                                    returnSectorsRef.current[0].JourneyDate,
                                  ),
                                  DATE_MONTH_YEAR_VIEW_FORMAT,
                                )}
                              </span>
                              <span>
                                {formatTimeStringAmPmFormat(
                                  returnSectorsRef.current[0].DepartureTime,
                                )}
                              </span>
                            </div>
                            <div className="fs-12 grey-color">
                              {`${returnSectorsRef.current[0].Origin} - ${
                                returnSectorsRef.current[0].OriginFullName
                              } ${getTerminal(
                                returnSectorsRef.current[0].AirportTerminal.toString().split(
                                  ',',
                                )[0],
                              )}`}
                            </div>
                          </div>
                        </Col>
                        <Col lg={4} md={4} sm={6} xs={6}>
                          <div>
                            <div className="fs-12 primary-color mb-1">
                              Arrival
                            </div>
                            <div className="fw-600 fs-16 d-flex align-items-center gap-1">
                              {returnSectorsRef.current[
                                returnSectorsRef.current.length - 1
                              ].ArrivalDate && (
                                <span>
                                  {formatDate(
                                    getNewDate(
                                      returnSectorsRef.current[
                                        returnSectorsRef.current.length - 1
                                      ].ArrivalDate,
                                    ),
                                    DATE_MONTH_YEAR_VIEW_FORMAT,
                                  )}
                                </span>
                              )}
                              <span>
                                {formatTimeStringAmPmFormat(
                                  returnSectorsRef.current[
                                    returnSectorsRef.current.length - 1
                                  ].ArrivalTime,
                                )}
                              </span>
                            </div>
                            <div className="fs-12 grey-color">
                              {`${
                                returnSectorsRef.current[
                                  returnSectorsRef.current.length - 1
                                ].Destination
                              } - ${
                                returnSectorsRef.current[
                                  returnSectorsRef.current.length - 1
                                ].DestinationFullName
                              } ${getTerminal(
                                returnSectorsRef.current[
                                  returnSectorsRef.current.length - 1
                                ].AirportTerminal.toString().split(',')[1],
                              )}`}
                            </div>
                          </div>
                        </Col>
                        <Col
                          lg={2}
                          md={2}
                          sm={6}
                          xs={12}
                          className="d-flex align-items-center"
                        >
                          <div className="d-flex flex-column align-items-center gap-1 justify-content-center">
                            <div className="secondary-color">
                              {getFightNumbers(returnSectorsRef.current)}
                            </div>
                            <div className="fs-12 grey-color">
                              {flightRecordRef.current.PassengerFirstName}{' '}
                              {flightRecordRef.current.PassengerLastName}
                            </div>
                          </div>
                        </Col>
                        <Col
                          lg={2}
                          md={2}
                          sm={6}
                          xs={12}
                          className="d-flex align-items-center"
                        >
                          <div>
                            <AppFlightLogo
                              width="30px"
                              height="30px"
                              carrier={returnSectorsRef.current[0].Carrier.substring(
                                0,
                                2,
                              )}
                              className="vertical-bottom"
                              style={{
                                marginLeft: '5px',
                              }}
                            />
                          </div>
                        </Col>
                      </Row>
                    )}
                  </Col>
                )}
                <Col
                  lg={2}
                  md={2}
                  sm={6}
                  xs={12}
                  className="d-flex justify-content-end align-items-center"
                >
                  {['confirmed'].indexOf(
                    flightRecordRef.current.BookingStatus.toLowerCase(),
                  ) > -1 && (
                    <div className="gap-1 fw-500 d-flex flex-column align-items-end">
                      <AppLink
                        linkText="Cancel"
                        variant="primary"
                        isLink
                        target="_blank"
                        href={`/flight/cancellation/${flightRecordRef.current.Txid}`}
                      />
                      <AppLink
                        linkText="Reshedule"
                        variant="primary"
                        isLink
                        target="_blank"
                        href={`/flight/reshedule/${flightRecordRef.current.Txid}`}
                      />
                    </div>
                  )}
                </Col>
              </Row>
            </div>
          </>
        ))}
      {showDetailsSidebar && (
        <FlightBookingDetailsSidebar
          onClose={handleCloseDetailsSidebar}
          isOpen={showDetailsSidebar}
          txid={selectedTxidRef.current}
          flightRecord={flightRecordRef.current}
        />
      )}
    </div>
  );
}

FlightListCard.propTypes = {
  transaction: PropTypes.any.isRequired,
  txType: PropTypes.any.isRequired,
};

export default FlightListCard;
